/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Record Type master data
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Route definitions
 * - Privilege name for role restrictions
 * - Table columns indicated as fields
 * - Action buttons on top of the table indicated as tableActions
 * - Action buttons per item inside the table indicated as entryActions
 * - Breadcrumbs definition
 *
 */
export default function (vm) {
  return {
    name: 'recordTypeTable',
    collectionName: 'recordType',
    dataView: 'default',
    label: 'Record Type',
    tableHeader: 'Record Type',
    route: {
      updateMultiple: 'recordType',
      list: 'recordType',
      deleteMultiple: 'recordType',
      upload: 'recordType'
    },
    hideSelect: false,
    privilege: 'canViewAllRecordType',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'Record Type',
          value: 'value'
        }
      }
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Add',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPostRecordType',
        action: () => {
          vm.$emit('modalChange', 'create')
        }
      }
    ],
    entryActions: [
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewRecordType',
        action: (item) => {
          vm.$emit('modalChange', 'view', item._id)
        }
      },
      {
        id: 'edit',
        icon: 'mdi-pencil',
        privilege: 'canViewRecordType',
        action: (item) => {
          vm.$emit('editRow', 'edit', item._id)
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'Record Type'
        }
      ]
    }
  }
}
